import { instanceApi } from '../../services';
import { ResetPassword } from './RestorePasswordModel';

export const restorePassword = (resetPass: ResetPassword): any => instanceApi.post('auth/users/forgotpassword', resetPass);
